export default{
  ResponseCode:{
    CODE_SUCCESS:0,
    CODE_FAIL:1,
    CODE_NOT_LOGON:100,
    CODE_NO_PERMISSION:101,
    CODE_EXISTS:1301
  }
}